module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h2', {
    staticClass: "chapnum"
  }, [_vm._v("5")]), _vm._v(" "), _c('h2', {
    staticClass: "chaptitle"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Stained Glass Window Commemorating the Marriage of King Henry VIII to Katherine of Aragon, St Margaret’s Church, Westminster")])])]), _vm._v(" "), _c('h3', {
    staticClass: "sub_section"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("The Wedding of Henry VIII and Katherine of Aragon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("In the east window of St Margaret’s Church, Westminster, there is a Flemish glass window which commemorates the marriage on 11 June 1509 of Henry and Katherine of Aragon, who are the kneeling figures featured in the bottom left and bottom right-hand corners. It is believed that the window was created in Holland in about 1526 and features the crucifixion of Jesus Christ")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindentt"
  }, [_vm._v("Katherine, the daughter of Isabella I of Castile and Ferdinand II of Aragon, had married Henry’s elder brother, Prince Arthur, in 1501, but he died five months later. In order to maintain and secure Anglo-Spanish relations King Ferdinand II offered their daughter in marriage to Arthur’s brother, Prince Henry, who was six years her junior. A treaty of marriage was agreed at Richmond Palace on 21 June 1503 and was authorised on 3 March 1504 when King Henry VII signed the treaty which specified that betrothal of Henry, who was aged 12, and Katherine, aged 17, would be sanctified on 28 June 1505, when Henry turned 14. It stipulated that Ferdinand II would pay a second instalment of the marriage dowry, in addition to the payment relating to her marriage to Arthur. There was a problem, however, because canon law was based on a verse from Leviticus in the Bible which stated that ‘if a man shall take his brother’s wife, it is an unclean thing, he hath uncovered his brother’s nakedness; they shall be childless’ (Leviticus 8.16). Although Pope Julius II in Rome granted a special dispensation allowing Henry to marry Katherine, Henry VII kept her in limbo, living in a state of penury. He was saving his son for a marriage to another royal princess, where an alliance could be forged that would be politically and financially more advantageous and affluential. It was on his deathbed that he commanded his son to marry Katherine. In a letter written by Henry VIII to Margaret of Savoy, daughter of Emperor Maximilian, on 27 June 1509 he wrote:")]), _vm._v(" "), _c('div', {
    staticClass: "quote"
  }, [_c('p', {
    staticClass: "quote"
  }, [_vm._v("True it is, … that for the consideration which we are bound to have for the treaty and appointment that was a long time made, promised, accorded and sworn between the late King our lord and father and our father-in-law and mother-in-law, the King of Aragon and the Queen of Spain, his consort, concerning the marriage of ourself to the Lady Katherine their daughter, and considering also the betrothals that were afterwards made between us and her "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("per verba pruescenti")]), _vm._v(" [contract of marriage]; we being come to full age, as well among divers wise counsels, honourable instruction and behests "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _vm._v("that the King, our said late lord and father, gave us when he summoned us before him, he being then upon his death bed, he gave us express command that we should take in marriage the Lady Katherine, in fulfilment of the said treaty and appointment of the said betrothals."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/107_Notes#rfnch05_6",
      "id": "fnch05_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0028-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Stained glass window commemorating the betrothal of Henry VIII to Katherine of Aragon. (Author’s Collection)")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0029-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Detailed image of King Henry VIII within the stained glass window. (Author’s Collection)")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("According to Hall, after Henry VII’s death, counsellors recommended that before the coronation Prince Henry should marry. The motivation for the marriage was based on it being ‘honourable and profitable to his realm … least she having so great a dowry, might marry out of the realm, which should be unprofitable to him’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/107_Notes#rfnch05_7",
      "id": "fnch05_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" Also, there was an urgent need for an heir to the throne to be born to ensure the line of succession, preserve the Tudor dynasty and prevent a civil war on the scale of the Wars of the Roses, which had been fought during the previous century. Henry VIII also wanted an alliance with Spain in order to confront France. Thirteen days before his coronation, the king married Katherine of Aragon in the Queen’s Closet at Greenwich Palace in a private ceremony officiated by William Warham, Archbishop of Canterbury on 11 June 1509.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although the marriage was arranged and intended to preserve Anglo-Spanish relations, there is evidence to suggest that Henry married Katherine for love. In a letter to King Ferdinand II, dated 26 July 1509, Henry wrote of his strong feelings of devotion for his wife, in the third person, intimating if he was not obliged for political reasons, he would have married her anyway: ‘The bond between them is now so strict that all their interests are common, and the love he bears to Katherine is such, that if he were still free he would choose her in preference to all others.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/107_Notes#rfnch05_8",
      "id": "fnch05_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27d54415","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/011_Chapter005.vue
// module id = 90
// module chunks = 0